export const SITE_URL = 'https://www.jwk.me';

export const DISQUS_CONFIG = ({ id, title, pathname }) => {
  return {
    url: `${SITE_URL}${pathname}`,
    identifier: id,
    title,
  };
};
